module.exports = __webpack_public_path__ + "img/copyright.1b09e44e.svg";